import PropTypes from "prop-types"
import React, { useState } from "react"
import { Input, Button, Icon } from "atomize"
import { theme } from "../settings/config"
import { passwordIsValid } from "../utils/func.utils"

TextInput.propTypes = {
	handleChange: PropTypes.func,
	placeholder: PropTypes.string,
	type: PropTypes.string,
	value: PropTypes.any,
}

TextInput.defaultProps = {
	placeholder: "",
	value: "",
	handleChange: null,
	type: "text",
}

const inputIsValid = (input, type) => {
	if (input === "") return true
	switch (type) {
		case "password":
			return passwordIsValid(input)
		default:
			return true
	}
}

function TextInput({
	placeholder,
	handleChange,
	handlePaste,
	value,
	type,
	disabled,
	submitAction,
	textTransform,
	suffix,
	m,
	// il fondo del campo: bianco sul fondo caldo dei fogli, caldo dentro una
	// scheda bianca (l'accesso dell'app)
	bg = "surface",
	...others
}) {
	const [isValid, setValidState] = useState(true)
	const [showPassword, setShowPassword] = useState(false)

	return (
		<Input
			bg={bg}
			m={m ?? { b: "0.5rem" }}
			value={value}
			rounded="20px"
			type={showPassword ? "text" : type}
			border="3px solid"
			borderColor={isValid ? theme.colors[bg] ?? bg : theme.colors.error}
			focusBorderColor={isValid ? theme.colors.gunmetal : theme.colors.error}
			textColor={disabled ? theme.colors.text_light : theme.colors.text}
			textTransform={textTransform}
			p={{ x: "1rem" }}
			h="3.5rem"
			disabled={disabled}
			placeholder={placeholder}
			onBlur={() => {
				inputIsValid(value, type) ? setValidState(true) : setValidState(false)
			}}
			onChange={e => {
				handleChange(e)
				inputIsValid(e.target.value, type, isValid) && setValidState(true)
			}}
			onPaste={e => {
				if (handlePaste) {
					handlePaste(e)
					inputIsValid(e.target.value, type, isValid) && setValidState(true)
				}
			}}
			onKeyPress={e => e.key === "Enter" && submitAction && submitAction()}
			suffix={
				type === "password" ? (
					<Button
						pos="absolute"
						onClick={() => setShowPassword(!showPassword)}
						bg="transparent"
						w="3rem"
						top="0.5rem"
						right="0"
						rounded={{ r: "md" }}>
						<Icon
							name={showPassword ? "EyeSolid" : "Eye"}
							color={showPassword ? theme.colors.gunmetal : theme.colors.text_light}
							size="16px"
						/>
					</Button>
				) : (
					<>{suffix}</>
				)
			}
			{...others}
		/>
	)
}

export default TextInput
